import './../css/style.scss';
import "@vpsoftware/vprealestate-www/modernizr";
import {initCustomCarousel} from "./custom-carousel";

import {
    BuildingElement, DefaultPermissions, initCookieConsent, initializePlans, initPlanButtons, initGalleries, initTable,
    FloorPlanElement, isFloor, filterTables
} from "@vpsoftware/vprealestate-www";
import {loadFloor, loadFloorLevel, planOptions} from "./plan.custom";
import {initPropertiesFilters} from "./properties-filters";
import {initPriceHistoryButtons} from "./history-price";
import {Modal, Carousel} from "bootstrap";
import {initFavoriteProperties} from "./favorite-properties";

document.addEventListener('DOMContentLoaded', () => {
    initCookieConsent(DefaultPermissions);
    initPreview();
    initCarousels();
    initCustomCarousel();
    initTables();
    initGalleries('.gallery', 'a[data-gal-webp]');
    initPriceHistoryButtons();
    initModals();
    initFavoriteProperties();
    scrollToTopBtnInit();
    
    if (document.location.pathname.includes('Wyszukaj')) {
        document.location.hash = 'results';
    }
});

function initModals() {
    const modal3D = document.getElementById('modal3D');
    if (modal3D) {
        modal3D.addEventListener('show.bs.modal', (event: Modal.Event) => {
            const button = event.relatedTarget;
            let title: string;
            let link: string;
            if (button.hasAttribute('data-bs-projection3DLink')) {
                title = 'Rzut 3D';
                link = button.getAttribute('data-bs-projection3DLink');
            }
            if (button.hasAttribute('data-bs-walk3DLink')) {
                title = 'Wirtualny spacer';
                link = button.getAttribute('data-bs-walk3DLink');
            }
            title = `${button.getAttribute('data-bs-propertyName')} - ${title}`.trim();
            modal3D.ariaLabel = title;
            modal3D.querySelector('.modal-title').textContent = title;
            modal3D.querySelector('iframe').src = link;
        });
        modal3D.addEventListener('hide.bs.modal', () => {
            modal3D.querySelector('iframe').src = '';
        });
    }
}

function initPreview() {
    const preview = document.querySelector('.preview-banner');
    if (!preview)
        return;
    
    preview.querySelector('.hide-banner').addEventListener('click', () => {
        preview.classList.add('d-none');
    });
}

function initCarousels() {
    const style = window.getComputedStyle(document.body);
    let cardsPerSlide = 1;
    if (window.matchMedia(`(min-width: ${style.getPropertyValue('--bs-breakpoint-xxl')})`).matches)
        cardsPerSlide = 4;
    else if (window.matchMedia(`(min-width: ${style.getPropertyValue('--bs-breakpoint-xl')})`).matches)
        cardsPerSlide = 3;
    else if (window.matchMedia(`(min-width: ${style.getPropertyValue('--bs-breakpoint-md')})`).matches)
        cardsPerSlide = 2;
    
    document.querySelectorAll('.carousel.multiple-items-on-slide').forEach(carousel => {
        const progress = carousel.querySelector('.progress');
        const progressBar = progress.querySelector<HTMLElement>('.progress-bar');
        const carouselInner = carousel.querySelector('.carousel-inner');
        
        function setProgressWidth(value: number) {
            progressBar.style.width = `${value}%`;
            progress.ariaValueNow = `${value}`;
        }
        
        if (cardsPerSlide === 1) {
            const cardCount = carouselInner.querySelectorAll('.carousel-item').length;
            let currentCard = 1;
            setProgressWidth(currentCard / cardCount * 100);
            carousel.classList.add('slide');
            carousel.addEventListener('slide.bs.carousel', e => {
                if (e.direction === "right") {
                    currentCard--;
                }
                else {
                    currentCard++;
                }
                setProgressWidth(currentCard / cardCount * 100);
            });
        }
        else {
            let scrollPosition = 0;
            const carouselWidth = carouselInner.scrollWidth;
            const cardWidth = carousel.querySelector<HTMLElement>('.carousel-item').offsetWidth;
            
            setProgressWidth((scrollPosition + cardWidth * cardsPerSlide) / carouselWidth * 100);

            carousel.querySelector('.carousel-control.prev').addEventListener('click', () => {
                if (scrollPosition > 0) {
                    scrollPosition -= cardWidth;
                    carouselInner.scroll({ left: scrollPosition, behavior: 'smooth' });
                    setProgressWidth((scrollPosition + cardWidth * cardsPerSlide) / carouselWidth * 100);
                }
            });
            carousel.querySelector('.carousel-control.next').addEventListener('click', () => {
                if (scrollPosition < (carouselWidth - cardWidth * cardsPerSlide)) {
                    scrollPosition += cardWidth;
                    carouselInner.scroll({ left: scrollPosition, behavior: 'smooth' });
                    setProgressWidth((scrollPosition + cardWidth * cardsPerSlide) / carouselWidth * 100);
                }
            });
            new Carousel(carousel, { interval: false, wrap: false });
        }
    });
}

function initTables() {
    initTable({
        'tableSelector': '.table.offer-table',
        hasExpansionRow: true
    });

    document.querySelectorAll('.home-completed').forEach(table => {
        const checkbox = table.querySelector<HTMLInputElement>('.show-sold');
        if (!checkbox) return;
        
        filterTables(`.home-completed:has(#${checkbox.id}) .table.offer-table`, obj => obj.stat !== 2);
        checkbox.addEventListener('change', () => {
            filterTables(`.home-completed:has(#${checkbox.id}) .table.offer-table`, obj => checkbox.checked ? true : obj.stat !== 2);
        });
    });

    document.querySelectorAll<HTMLElement>("table.offer-table .table-details").forEach(toggle => {
        toggle.addEventListener("click", (e) => {
            let open = toggle.classList.toggle("open");
            let expandedRow = toggle.closest('tr').nextElementSibling as HTMLTableRowElement;
            expandedRow.classList.toggle('more-info-house-open', open);
            if (open && expandedRow && expandedRow.getAttribute('data-lazy-load') === 'true') {
                loadPropertyThumbnails(expandedRow).then(() => {
                    expandedRow.removeAttribute('data-lazy-load');
                });
            }
        });
    });
}

async function loadPropertyThumbnails(container: HTMLElement): Promise<void> {
    const propertyId = container.dataset.propertyId;

    if (!propertyId) return;

    try {
        const response = await fetch(`/PropertyThumbnails?propertyId=${propertyId}`);

        if (!response.ok)
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);

        const thumbnails = await response.json();
        
        //plans
        const planContainer = container.querySelector('.plan-images-container');
        if (planContainer) {
            planContainer.innerHTML = '';

            if (thumbnails.planImages && thumbnails.planImages.length > 0) {
                thumbnails.planImages.forEach((plan: any, index: number) => {
                    const isFirst = index === 0;
                    const linkElement = createImageElement(plan, isFirst ? '' : 'd-none');
                    planContainer.classList.remove('align-items-center');
                    planContainer.classList.add('align-items-start');
                    planContainer.appendChild(linkElement);
                });
            }
        }

        //path image
        const imageContainer = container.querySelector('.property-image-container');
        if (imageContainer) {
            imageContainer.innerHTML = '';

            if (thumbnails.propertyImage) {
                const linkElement = createImageElement(thumbnails.propertyImage);
                imageContainer.classList.remove('align-items-center');
                imageContainer.classList.add('align-items-start');
                imageContainer.appendChild(linkElement);
            }
        }

        initGalleries('table.offer-table tbody tr.more-info-house[data-property-id="' + propertyId + '"] .main-col .details', 'a[data-gal-webp]');

    } catch (error) {
        console.error('Błąd ładowania miniaturek:', error);
        
        const containers = [
            container.querySelector('.plan-images-container'),
            container.querySelector('.property-image-container')
        ];

        containers.forEach(cont => {
            if (cont) {
                cont.innerHTML = '<div class="text-muted small">Błąd ładowania obrazów</div>';
            }
        });
    }
}

function createImageElement(imageData: any, className: string = '') {
    const linkElement = document.createElement('a');
    linkElement.className = className;
    linkElement.href = imageData.originalJpg;
    linkElement.setAttribute('data-gal-webp', imageData.originalWebp);

    const pictureElement = document.createElement('picture');
    const sourceElement = document.createElement('source');
    sourceElement.srcset = imageData.planImageWebp;
    sourceElement.type = 'image/webp';

    const imgElement = document.createElement('img');
    imgElement.loading = 'lazy';
    imgElement.src = imageData.planImageJpg;
    imgElement.className = 'img-fluid';
    imgElement.alt = 'Plan';

    pictureElement.appendChild(sourceElement);
    pictureElement.appendChild(imgElement);
    linkElement.appendChild(pictureElement);

    return linkElement;
}

export async function initializeDefaultPlan() {
    let plans = await initializePlans('picture[data-path]', planOptions);
    if (plans[0]) {
        initPlanButtons<BuildingElement>(
            {
                plan: plans[0],
                buttonsSelector: 'a[data-building-slug]',
                dataProperty: 'buildingSlug',
                accessorFn: (x: BuildingElement) => x.sl
            });
    }
}

export async function initializeBuildingPlan() {
    let plans = await initializePlans('picture[data-path]', planOptions);
    if (plans[0]) {
        initPlanButtons<FloorPlanElement>(
            {
                plan: plans[0],
                buttonsSelector: 'button[data-level]',
                dataProperty: 'level',
                accessorFn: (x: FloorPlanElement) => "" + x.fl
            });
        document.querySelectorAll<HTMLAnchorElement>('.floor-button').forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                document.querySelectorAll<HTMLAnchorElement>('.floor-button').forEach(btn => btn.classList.remove('checked'));
                btn.classList.add('checked');
                let floorNum = Number(btn.dataset['level']);
                let floorLayer = plans[0].childElements.find(l => isFloor(l.object) && l.object.fl === floorNum);
                if (floorLayer) {
                    loadFloor(floorLayer.object as FloorPlanElement);
                } else {
                    let floorLayerNotDrawn = plans[0].data.find(l => isFloor(l) && l.fl === floorNum);
                    if (floorLayerNotDrawn) {
                        loadFloor(floorLayerNotDrawn as FloorPlanElement)
                    } else {
                        loadFloorLevel(floorNum);
                    }
                }
            });
        });
    }
}

export async function InitializePropertyPage() {
    const buttonsContainer = document.querySelector<HTMLDivElement>('.explore-property .plan-buttons');
    if (!buttonsContainer) return;
    buttonsContainer.querySelector('#planButton')?.addEventListener('click', LoadPlan);
    buttonsContainer.querySelector('#projectionButton')?.addEventListener('click', LoadProjection);
    buttonsContainer.querySelector('#walkButton')?.addEventListener('click', LoadWalk);
}

export async function LoadPlan(event: PointerEvent) {
    event.preventDefault();
    document.querySelectorAll('.plan-buttons button').forEach(btn => btn.classList.remove('checked'));
    (event.currentTarget as any).classList.add('checked');
    document.getElementById('plan').classList.remove('d-none');

    document.getElementById('projection')?.classList.add('d-none');
    document.getElementById('walk')?.classList.add('d-none');
}

export async function LoadProjection(event: PointerEvent) {
    event.preventDefault();
    if (window.matchMedia('(min-width: 768px)').matches) {
        document.querySelectorAll('.plan-buttons button').forEach(btn => btn.classList.remove('checked'));
        (event.currentTarget as any).classList.add('checked');
        document.getElementById('projection').classList.remove('d-none');

        document.getElementById('plan')?.classList.add('d-none');
        document.getElementById('walk')?.classList.add('d-none');   
    }
    else {
        new Modal('#projection3DModal').show();
    }
}

export async function LoadWalk(event: PointerEvent) {
    event.preventDefault();
    if (window.matchMedia('(min-width: 768px)').matches) {
        document.querySelectorAll('.plan-buttons button').forEach(btn => btn.classList.remove('checked'));
        (event.currentTarget as any).classList.add('checked');
        document.getElementById('walk').classList.remove('d-none');

        document.getElementById('plan')?.classList.add('d-none');
        document.getElementById('projection')?.classList.add('d-none');
    }
    else {
        new Modal('#walk3DModal').show();
    }
}

export function initializeBuildingPage() {
    initializeBuildingPlan();
    initPropertiesFilters();
}

export function initializeAboutUsPage() {
    const showAllBtn = document.querySelector('.show-all-realized-investments-button');
    const realizedInvestments = document.querySelector('.realized-investments');
    let maxRealizedInvestmentsCount = 1;
    if (window.matchMedia('(min-width: 768px)').matches) {
        maxRealizedInvestmentsCount = 3;
    }
    if (document.querySelectorAll('.realized-investment').length <= maxRealizedInvestmentsCount) {
        showAllBtn.classList.add('d-none');
        realizedInvestments.classList.remove('collapsed');
    } else {
        showAllBtn.addEventListener('click', e => {
            showAllBtn.classList.add('d-none');
            realizedInvestments.classList.remove('collapsed');
        });
    }
}

export function initializeContactUsPage() {
    if (window.location.hash === '#privacyPolicy') {
        document.querySelector<HTMLButtonElement>('button[aria-controls="privacyPolicyCollapse"]').click();
    }
}

declare const vpcCaptchaPublicKey: string;

export function initContactForm(alternativeText: boolean = false) {
    let contactFormElement = document.getElementById('contactForm');
    let contactForm = document.querySelector<HTMLFormElement>('.contact-form');
    if (!contactForm || !contactForm) {
        return;
    }

    let formContainer = contactFormElement.querySelector<HTMLElement>('.form-container');
    let formMessage = contactFormElement.querySelector<HTMLElement>('.form-message');
    contactForm.addEventListener('submit', event => {
        event.preventDefault();
        event.stopPropagation();
        contactForm.classList.add('was-validated');

        if (!contactForm.checkValidity()) {
            return;
        }

        formContainer.classList.add('invisible');
        formMessage.classList.remove('d-none');
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/ContactMail', true);
        xhr.responseType = 'json';
        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        const formData = new FormData(contactForm);
        xhr.addEventListener('readystatechange', function () {
            if (this.readyState === XMLHttpRequest.DONE) {

                if (this.status >= 200 && this.status <= 299) {
                    if (alternativeText) {
                        formMessage.innerHTML = 'Dziękujemy za kontakt<br/>Zastrzegamy sobie prawo do kontaktu jedynie w przypadku wybranych ofert.';
                    } else {
                        formMessage.innerHTML = 'Dziękujemy za kontakt<br/>Nasz konsultant skontaktuje się w ciągu 48 godzin';
                    }
                } else {
                    formMessage.innerHTML = '<div class="unsuccessful">Coś poszło nie tak</div>';
                    let button = document.createElement('button');
                    button.classList.add('mt-3', 'mx-auto', 'btn', 'btn-primary');
                    button.innerText = "Powrót";
                    button.addEventListener('click', () => {
                        formContainer.classList.remove('invisible');
                        formMessage.classList.add('d-none');
                        formMessage.removeChild(button);
                    });
                    formMessage.appendChild(button);
                }
            }
        });
        if (typeof vpcCaptchaPublicKey !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(vpcCaptchaPublicKey, { action: 'submit' }).then(
                    function (token) {
                        formData.append('token', token);
                        xhr.send(serializeFormData(formData));
                    }, err => {
                        console.error(err);
                        formMessage.innerHTML = '<div class="unsuccessful">Coś poszło nie tak</div>';
                        let button = document.createElement('button');
                        button.classList.add('mt-3', 'mx-auto', 'btn', 'btn-primary');
                        button.innerText = "Powrót";
                        button.addEventListener('click', () => {
                            formContainer.classList.remove('invisible');
                            formMessage.classList.add('d-none');
                            formMessage.removeChild(button);
                        });
                        formMessage.appendChild(button);
                    }
                );
            });
        }
        else {
            xhr.send(serializeFormData(formData));
        }
    });
}

function serializeFormData(formData) {
    const retVal = {};
    for (const [name, value] of formData) {
        retVal[name] = value;
    }
    return JSON.stringify(retVal);
}

export function initNewsletterForm(investmentSlug, buildingSlug) {
    let successModal = new Modal(document.getElementById('subscribeSuccessModal'));
    let errorModal = new Modal(document.getElementById('subscribeErrorModal'));
    let subscribeModal = new Modal(document.getElementById('subscribeModal'));
    let submitButton = document.getElementById('newsletterSubmit');
    let spinner = submitButton.querySelector('.spinner-grow');
    let form = document.getElementById('newsletterForm') as HTMLFormElement;
    document.getElementById('subscribeBtn').addEventListener('click', () => {
        spinner.classList.add('d-none');
        form.classList.remove('was-validated');
        subscribeModal.show();
    });
    form.addEventListener('submit', event => {
        event.preventDefault();
        event.stopPropagation();
        form.classList.add('was-validated');
        if (!form.checkValidity()) {
            return;
        }
        spinner.classList.remove('d-none');
        const formData = new FormData(form);
        formData.set('investmentSlug', investmentSlug);
        if (buildingSlug) {
            formData.set('buildingSlug', buildingSlug);
        }
        form.querySelectorAll('input, button').forEach(x => x.setAttribute('disabled', 'disabled'));

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/NewsletterSubscribe', true);
        xhr.responseType = 'json';
        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        xhr.addEventListener('readystatechange', function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                if (this.status >= 200 && this.status <= 299) {
                    subscribeModal.hide();
                    successModal.show();
                } else {
                    subscribeModal.hide();
                    errorModal.show();
                }
            }
        });

        if (typeof vpcCaptchaPublicKey !== 'undefined') {
            grecaptcha.ready(function() {
                grecaptcha.execute(vpcCaptchaPublicKey, { action: 'submit' }).then(
                    function (token) {
                        formData.append('token', token);
                        xhr.send(serializeFormData(formData));
                    }, err => {
                        console.error(err);
                        subscribeModal.hide();
                        errorModal.show();
                    }
                );
            });
        }
        else {
            xhr.send(serializeFormData(formData));
        }

    }, false);
}

function scrollToTopBtnInit() {
    const scrollToTopBtn = document.querySelector<HTMLElement>('.btn-scroll-to-top');
    if (!scrollToTopBtn)
        return;

    if (window.scrollY > 0)
        scrollToTopBtn.classList.add('shown');

    window.addEventListener('scroll', function () {
        scrollToTopBtn.classList.toggle('shown', window.scrollY > 0);
    });
    scrollToTopBtn.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}